module.exports = __webpack_public_path__ + "static/tampa-c7b2642f0aaabaa2a1971065b93a2c1f.png";